import { Component,  OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-days-actual',
  templateUrl: './select-days-actual.component.html',
  styleUrls: ['./select-days-actual.component.scss']
})
export class SelectDaysActualComponent implements OnDestroy {

  public items: any[] = [
    { value: 1, name: 'Actual' },
    { value: 7, name: 'Últ. 7 días' },
    { value: 14, name: 'Últ. 14 días' },
    { value: 30, name: 'Últ. 30 días' },
    { value: 99, name: 'Mes Actual' },
    { value: 0, name: 'Mes Anterior' }
  ];

  public daysAgoActual: any = [];
  public ngxDisabled = false;
  daysAgoActual$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.daysAgoActual$ = this.sharedService.sharedDaysAgoActual.subscribe(daysAgoActual => {
      this.daysAgoActual = daysAgoActual;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.daysAgoActual$.unsubscribe();
  }

  changeDaysAgo(event: any) {
    this.daysAgoActual = event;
    this.sharedService.nextDaysAgoActual = this.daysAgoActual;
  }
}
